import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { take } from 'rxjs';
import { slideInOut } from '../../../animations/slide-in-out.animation';

@Component({
  selector: 'skills-search-input',
  templateUrl: 'skills-search-input.component.html',
  styleUrls: ['skills-search-input.component.scss'],
  animations: [slideInOut]
})
export class SkillsSearchInputComponent {

  @ViewChild('scrolledEl') scrolledEl: ElementRef | undefined;
  @ViewChild('selectEl') selectEl: ElementRef | undefined;
  @Input() isSubmitted = true;
  @Input() label = '';
  @Input() grayBg = true;
  @Input() control: FormControl = new FormControl(null);
  @Input() set items(vals) {
    if (vals) { 
      this.allItems = vals;
    }
  }
  @Output() skillChanged = new EventEmitter<any>();

  showItems = false;
  inputFocused = false;
  openPositionTop = false;
  allItems = null;

  constructor() { }

  onFocus(val: boolean) {
    this.inputFocused = val;
    if (this.inputFocused) {
      this.showDropdown();
    } else {
      setTimeout(() => this.clear(), 300);
    }
  }

  showDropdown(val: boolean = true) {
    this.showItems = val;
    if (this.selectEl) {
      const position = this.selectEl.nativeElement.getBoundingClientRect().top;
      this.openPositionTop = window.innerHeight - position < 240;
    }
  }

  selectSkill(branch, skill, selected) {
    this.skillChanged.emit({ branch, skill, selected });
    this.showDropdown(false);
    this.selectEl.nativeElement.value = '';
  }
  
  clear() {
    this.allItems = null;
    this.control.reset();
    // this.selectEl.nativeElement.focus();
  }
}
